module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_2-63f23fda74b1cc31b66f58ed0c471578.png";